/* esm.sh - applesauce-core@5.2.0/dist/models/mailboxes */
export * from "/*applesauce-core@5.2.0/esnext/dist/models/mailboxes.mjs";
